import React from "react";
import { convertTimeString } from "./TimeConversion";
import { Document, Page, Text, View, Image, StyleSheet, Font } from "@react-pdf/renderer"
import { formatNoteName } from "./FormatNoteNameAndText";
import PropTypes from "prop-types";

Font.register({ family: 'Space Mono', fonts: [
    {
        src: "/fonts/SpaceMono.ttf",
    }, {
        src: "/fonts/SpaceMono.ttf",
        fontWeight: '600',
    }
]});

const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        padding: 20,
    },
    section: {
        margin: 10,
        padding: 10,
        fontSize: 12,
    },
    title: {
        fontSize: 18,
        marginBottom: 10,
        textAlign: 'center',
    },
    image: {
        marginVertical: 10,
        marginHorizontal: 100,
        width: 10,
        height: 10,
    },
    divider: {
        width: "100%",
        border: "1px solid #f1f3f4",
        marginTop: 15,
    },
    titleText: {
        fontFamily: 'Space Mono',
        fontWeight: '600',
        fontSize: 14,
        paddingTop: 5,
    },
    headerText: {
        fontFamily: 'Space Mono',
        fontWeight: '600',
        color: '#5774f0',
        paddingTop: 15,
        fontSize: 11,
    },
    normalText: {
        fontFamily: 'Space Mono',
        fontSize: 9,
    }
});

const RenderStyledNote = ({ soapNote }) => {

    // Function to choose styles based on the content of the string
    const getTextStyle = (str) => {
        const occurrences = (str.match(/\*\*/g) || []).length;
        if (occurrences >= 2) {
            return styles.headerText; // Style for headers
        }
        return styles.normalText; // Default style for normal text
    };

    function splitByTitles(input) {
        const regex = /(\*\*[^*]+\*\*)/g;
        const result = input.split(regex).filter(part => part.trim() !== '');
        return result;
    }

    // Split the text by the headers and include them in the output
    const textSplitByHeaders = splitByTitles(soapNote)
    
    return <View>
        {textSplitByHeaders.map((str, index) => (
            <Text key={index} style={getTextStyle(str)}>
                {str.replace(/\*\*/g, '')}
            </Text>
        ))}
    </View>
}

RenderStyledNote.propTypes = {
    soapNote: PropTypes.string,
}


function NoteToPDF({ note, createdBy, noteType }) {
    let soapNote;

    if (note.user_edited_result.value) {
        soapNote = note.user_edited_result.value;
    } else {
        soapNote = note.generated_result.value;
    }

    return <Document>
        <Page size="A4" style={styles.page}>
            <View style={{display: "flex", alignItems: "flex-end"}}>
                <Image style={{width: "40%", maxHeight: "2in"}} src="/assets/logo.png" />
            </View>
            <View style={{paddingTop: 15}}>
                <Text style={styles.normalText}>
                    {createdBy}
                </Text>
            </View>
            <View>
                <Text style={styles.titleText}>
                    {formatNoteName(noteType)}
                </Text>
                <Text style={styles.normalText}>
                    {convertTimeString(note.created_at)}
                </Text>
            </View>
            <View style={styles.divider}/>
            <RenderStyledNote soapNote={soapNote} />
            <View style={styles.divider}/>
        </Page>
    </Document>
}

NoteToPDF.propTypes = {
    note: PropTypes.shape({ 
        user_edited_result: PropTypes.shape({ value: PropTypes.string }),
        generated_result: PropTypes.shape({ value: PropTypes.string }),
        created_at: PropTypes.string.isRequired,
    }),
    createdBy: PropTypes.string.isRequired,
    noteType: PropTypes.string.isRequired,
}

export default NoteToPDF;